export default __webpack_public_path__ + "static/media/kanit-medium.3ff0fbb9.svg";